
const colors = {
    'success': { 
        color: '#00A71F', 
        backgroundColor: '#DFF8E4', 
        borderColor: '#68C87A',
    },
    'error': { 
        color: '#D22827', 
        backgroundColor: '#FCE0E0', 
        borderColor: '#D22827',
    },
};

export default {
    state: {
        snackBarItems: [],
    },
    mutations: {
        addSnackBar:(state, item) => state.snackBarItems.unshift(item),
        removeSnackBar:(state, id) => state.snackBarItems = state.snackBarItems
            .filter((v) => {
                return v.id != id;
            }),
    },
    actions: {
        addSnack: (ctx, {
            message,
            color,
        }) => {
            if (!colors[color]) {
                console.warn('unknown color of snackbar message');
                return;
            }
            let id = `${Date.now()}_${ctx.state.snackBarItems.length}`;
            ctx.commit('addSnackBar', { id, message, color: colors[color]});
            setTimeout(() => {
                ctx.commit('removeSnackBar', id);
            }, 1500);
        },
    },
    getters: {
        snackbars: (state) => state.snackBarItems,
    },
};
